<!-- FinalAudioPlayer.svelte -->
<script>
    export let audioUrl;
  </script>
  
  <div class="final-audio-container">
    <h3>Sentient AI is Closer Than You Think. (Your Version)</h3>
    <p>Here's the full, one-of-a-kind version of the essay (conversation?) you just listened to, including the tangents and questions you and my AI clone chased.</p>
    
    <div class="player-container">
      <audio 
        controls 
        src={audioUrl}
        crossorigin="anonymous"
      />
      
      <div class="button-container">
        <a
          href={audioUrl}
          download
          class="button download"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Download Audio
        </a>
      </div>
    </div>
  </div>
  
  <style>
    .final-audio-container {
      max-width: 42rem;
      margin: 3rem auto;
      padding: 1.5rem;
      background-color: #f9f9f9;
      border-radius: 0.5rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      font-family: EB Garamond, serif;
    }
  
    h3 {
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 1rem;
    }
  
    p {
      text-align: center;
      color: #666;
      margin-bottom: 1.5rem;
    }
  
    .player-container {
      background-color: white;
      padding: 1rem;
      border-radius: 0.375rem;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }
  
    audio {
      width: 100%;
      margin-bottom: 1rem;
    }
  
    .button-container {
      display: flex;
      justify-content: center;
    }
  
    .button {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 0.375rem;
      font-weight: 500;
      color: white;
      text-decoration: none;
      transition: background-color 0.2s;
    }
  
    .button svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  
    .download {
      background-color: #0077b5;
    }
  
    .download:hover {
      background-color: #005885;
    }
  </style>